import { usePhoneStore } from '@hit/react-jssip';

const useActiveCall = () => {
  const calls = usePhoneStore((state) => state.calls);

  const oneToOneCalls = Object.values(calls).filter(
    (call) => call.isEstablished && !call.conferenceId
  );

  const attendedTransferCall = oneToOneCalls.find(
    (call) => call.completeTransfer
  );

  const call = attendedTransferCall ?? oneToOneCalls[0];

  return call;
};

export default useActiveCall;
